module.exports = __webpack_public_path__ + "media/img/referrals/modal-e54df3ec758548c9df8a54bccd1f0f73.png";